<script setup>
import { nextTick, onBeforeUnmount, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import AnalyticsConsent from "./components/AnalyticsConsent.vue";
import { trackEvent } from "./utils/analytics";

const route = useRoute();
let observer;

function observePage() {
  observer?.disconnect();
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.documentElement.classList.add("reduce-motion");
    document.querySelectorAll("[data-reveal]").forEach((element) => element.classList.add("is-visible"));
    return;
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -6% 0px" },
  );

  document.querySelectorAll("[data-reveal]").forEach((element) => observer.observe(element));
}

function updatePointer(event) {
  document.documentElement.style.setProperty("--pointer-x", `${event.clientX}px`);
  document.documentElement.style.setProperty("--pointer-y", `${event.clientY}px`);
}

function trackInteraction(event) {
  const target = event.target.closest?.("[data-analytics]");
  if (!target) return;
  trackEvent(target.dataset.analytics || "interaction", {
    label: target.dataset.analyticsLabel || target.textContent?.trim().slice(0, 80) || "",
  });
}

watch(
  () => route.fullPath,
  async () => {
    await nextTick();
    observePage();
  },
  { immediate: true },
);

onMounted(() => {
  window.addEventListener("pointermove", updatePointer, { passive: true });
  document.addEventListener("click", trackInteraction);
});

onBeforeUnmount(() => {
  observer?.disconnect();
  window.removeEventListener("pointermove", updatePointer);
  document.removeEventListener("click", trackInteraction);
});
</script>

<template>
  <a class="skip-link" href="#main">Ir al contenido</a>
  <RouterView />
  <AnalyticsConsent />
</template>
